
const Unathorized = () => {
  return (
    <div>Unathorized User</div>
  )
}

export default Unathorized